import { useState, useEffect } from "react";

function usePersonalProfile({ formValues, watch } = {}) {
  const [availableDays, setAvailableDays] = useState([]);
  const [profiles, setProfiles] = useState([0]);

  // Watch for changes in profile links from the form
  useEffect(() => {
    if (watch) {
      const profileLinks = watch("vendorAdditionalInfo.profile");

      if (
        profileLinks &&
        Array.isArray(profileLinks) &&
        profileLinks.length > 0
      ) {
        // Create an array of indices based on the number of profile links
        const profileIndices = Array.from(
          { length: profileLinks.length },
          (_, i) => i
        );

        // Only update if different from current state
        if (JSON.stringify(profileIndices) !== JSON.stringify(profiles)) {
          setProfiles(profileIndices);
        }
      }
    } else if (formValues?.vendorAdditionalInfo?.profile) {
      const profileLinks = formValues.vendorAdditionalInfo.profile;

      if (Array.isArray(profileLinks) && profileLinks.length > 0) {
        const profileIndices = Array.from(
          { length: profileLinks.length },
          (_, i) => i
        );

        if (JSON.stringify(profileIndices) !== JSON.stringify(profiles)) {
          setProfiles(profileIndices);
        }
      }
    }
  }, [
    watch
      ? watch("vendorAdditionalInfo.profile")
      : formValues?.vendorAdditionalInfo?.profile,
    profiles,
  ]);

  const addAnotherProfile = (index) => {
    setProfiles([...profiles, index + 1]);
  };

  const removeProfile = (index) => {
    setProfiles(profiles.filter((_, i) => i !== index));
  };

  const resetOnUnmount = () => {
    setAvailableDays([]);
    setProfiles([0]);
  };

  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    availableDays,
    setAvailableDays,
    addAnotherProfile,
    profiles,
    removeProfile,
  };
}

export default usePersonalProfile;
